import apiClient, { setToken, setStoredUser, clearToken, clearStoredUser } from "./apiClient";

export const login = async (email, password) => {
  const { data } = await apiClient.post("/auth/login", { email, password });
  const { user, token } = data.data;
  setToken(token);
  setStoredUser(user);
  return user;
};

export const logout = async () => {
  try {
    await apiClient.post("/auth/logout");
  } finally {
    clearToken();
    clearStoredUser();
  }
};
